// Quầng sáng dùng chung của các scene: bát giác bao đường tròn, alpha tính bằng phép toán trong
// shader (rẻ khi fill-rate thấp: WebGL phần mềm trong CI, máy yếu). Màu premultiplied cho blend NORMAL.
import { Geometry, Mesh, Shader } from 'pixi.js';

const GLOW_VERT = `precision mediump float;
attribute vec2 aVertexPosition;
attribute vec2 aUv;
uniform mat3 translationMatrix;
uniform mat3 projectionMatrix;
varying vec2 vUv;
void main() {
  vUv = aUv;
  gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
}`;
const GLOW_FRAG = `precision mediump float;
varying vec2 vUv;
uniform vec3 uColor;
uniform float uAlpha;
void main() {
  float a = 1.0 - clamp(length(vUv), 0.0, 1.0);
  a = uAlpha * a * a;
  gl_FragColor = vec4(uColor * a, a);
}`;

/** Quầng sáng tròn bán kính `radius`, alpha tính trong fragment shader (không texture lớn). */
export function glowMesh(
  color: number,
  radius: number,
): { mesh: Mesh<Shader>; uniforms: { uAlpha: number } } {
  // Bát giác bao đường tròn: ít điểm ảnh thừa ở góc hơn một hình vuông.
  const pos: number[] = [0, 0];
  const uv: number[] = [0, 0];
  const n = 8;
  const k = 1 / Math.cos(Math.PI / n);
  for (let i = 0; i <= n; i++) {
    const a = (i / n) * Math.PI * 2;
    pos.push(Math.cos(a) * radius * k, Math.sin(a) * radius * k);
    uv.push(Math.cos(a) * k, Math.sin(a) * k);
  }
  const idx: number[] = [];
  for (let i = 1; i <= n; i++) idx.push(0, i, i + 1);
  const geom = new Geometry()
    .addAttribute('aVertexPosition', pos, 2)
    .addAttribute('aUv', uv, 2)
    .addIndex(idx);
  const uniforms = {
    uColor: [((color >> 16) & 255) / 255, ((color >> 8) & 255) / 255, (color & 255) / 255],
    uAlpha: 0.55,
  };
  const shader = Shader.from(GLOW_VERT, GLOW_FRAG, uniforms);
  return { mesh: new Mesh(geom, shader), uniforms: shader.uniforms as { uAlpha: number } };
}
